export enum TimeValidationEnum {
  ShouldReplace = 'ShouldReplace',
}
